<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/f5qjST/tc-custom/9780740792465.jpg?1728259339717" alt="This image is the cover for the book Ebert's Bigger Little Movie Glossary"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ebert's Bigger Little Movie Glossary
      </h1>
      <p class="bookDescription body article font2">
        <b>An expanded glossary of movie clichés from the Pulitzer Prize–winning film critic. </b><br/><br/>The popular film critic offers a compilation of witty and wise observations about the film lexicon, including “Fruit Cart,” a chase scene through an ethnic or foreign locale, or “The Non-Answering Pet,” referring to a dead pet in a horror movie.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Roger Ebert
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?243b3150